import {SIAStationIcon, handlingIcon, scootIcon} from '@/assets/icons/station';
import {useAppSelector} from '@/hooks/redux';

const AirportIcon = ({
  airport,
  size = 14
}: {
  airport: string;
  size?: number;
}) => {
  const airlineStations = useAppSelector(
    (state) => state.airport.airlineStations
  );
  const isAirlineStation = airlineStations.includes(airport);
  // if (['WSSS'].includes(airport)) {
  //   return SIAStationIcon(size);
  // }
  if (isAirlineStation) {
    return SIAStationIcon(size);
  }
  return <></>;
};

export default AirportIcon;
